import { BookingIdRemarkRuleCreateRequest } from '../../../../integrated-client/models';

export interface IBookingCreateManagerV2RemarksEditorData extends BookingIdRemarkRuleCreateRequest {}

export interface IEditorData {
  bookingCreateManagerRemarksEditorData: IBookingCreateManagerV2RemarksEditorData;
  validation?: any;
}

export class BookingCreateManagerV2RemarksEditorData implements IBookingCreateManagerV2RemarksEditorData {
  id?: string | null;
  disabled?: boolean;
  description?: string | null;
  comment?: string | null;
  allowEdit?: boolean;
  constructor() {
    this.disabled = false;
  }
}

export class EditorData implements IEditorData {
  bookingCreateManagerRemarksEditorData: IBookingCreateManagerV2RemarksEditorData;
  validation?: any;

  constructor() {
    this.bookingCreateManagerRemarksEditorData = new BookingCreateManagerV2RemarksEditorData();
  }
}
